import { trackAPICall } from "@/services/SnowplowService";
import { getId } from "@/utils/OpportunityUtils";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { OpportunitiesApiService } from "./OpportunitiesApiService";

class Service {
  @trackAPICall("POST", "Notifications", "preference")
  public add(opportunityId: string, preference: object): Observable<string> {
    const url = `/api/suite/opportunities/${getId(opportunityId)}/notification-preferences`;

    return OpportunitiesApiService.post(url, preference).pipe(map((response) => response.data.id));
  }

  @trackAPICall("DELETE", "Notifications", "stopTutorial")
  public stopTutorial(): Observable<void> {
    const url = "/api/suite/notifications/tutorial";

    return OpportunitiesApiService.delete(url, {}).pipe(map(() => undefined));
  }
}

export const NotificationsService = new Service();
